import {IViewTypeStore} from "../../view_type/view_type_reducer";

export function getHitSearchSubmitLabel(offerListTitle: string, currentViewType: IViewTypeStore["current"], articleTitle?: string) {
    if (currentViewType === "article" && articleTitle) {
        return articleTitle;
    }

    if (currentViewType === "homepage") {
        return "Strona główna";
    }

    return offerListTitle.replace(" - rynekpierwotny.pl", "");
}
import {IViewTypeStore} from "../../view_type/view_type_reducer";

export function getHitSearchSubmitLabel(offerListTitle: string, currentViewType: IViewTypeStore["current"], articleTitle?: string) {
    if (currentViewType === "article" && articleTitle) {
        return articleTitle;
    }

    if (currentViewType === "homepage") {
        return "Strona główna";
    }

    return offerListTitle.replace(" - rynekpierwotny.pl", "");
}
